import { constants } from 'react-redux-firebase'

const SET_ERROR = 'auth/SET_ERROR'
const SIGNING_IN = 'auth/SIGNING_IN'
const SIGNING_IN_ERROR = 'auth/SIGNING_IN_ERROR'
const SIGNING_IN_SUCCESS = 'auth/SIGNING_IN_SUCCESS'
const SIGNING_OUT = 'auth/SIGNING_OUT'
const SIGNING_OUT_ERROR = 'auth/SIGNING_OUT_ERROR'
const SIGNING_OUT_SUCCESS = 'auth/SIGNING_OUT_SUCCESS'

const initialState = {
  error: '',
  initialized: false,
  isLoading: false,
  success: '',
}

export default (state = initialState, action) => {
  const { type, ...actionProps } = action
  switch (action.type) {
    case constants.actionTypes.AUTH_EMPTY_CHANGE:
    case constants.actionTypes.SET_PROFILE:
      return {
        ...state,
        initialized: true,
      }
    case SIGNING_IN:
    case SIGNING_OUT:
      return {
        ...state,
        error: '',
        isLoading: true,
        success: '',
      }
    case SIGNING_IN_ERROR:
    case SIGNING_IN_SUCCESS:
    case SIGNING_OUT_ERROR:
    case SIGNING_OUT_SUCCESS:
      return {
        ...state,
        ...actionProps,
        isLoading: false,
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.error,
      }
    default:
      return state
  }
}

const handleError =
  ({ err, type, ...other }) =>
  (dispatch) => {
    console.log({ err, type, ...other })
    const error = (err.message || err).replace('Firebase: ', '')
    dispatch({ ...other, error, type })
  }

export const setError = (error) => ({ error, type: SET_ERROR })

export const signIn =
  ({ email, password }) =>
  async (dispatch, getState, getFirebase) => {
    dispatch({ type: SIGNING_IN })
    try {
      await getFirebase().auth().signInWithEmailAndPassword(email, password)
      dispatch({ type: SIGNING_IN_SUCCESS })
      window.location.reload(false) // reload page to recheck mediavine
    } catch (err) {
      dispatch(handleError({ err, type: SIGNING_IN_ERROR }))
    }
  }

export const signOut = () => async (dispatch, getState, getFirebase) => {
  dispatch({ type: SIGNING_OUT })
  try {
    await getFirebase().auth().signOut()
    dispatch({ type: SIGNING_OUT_SUCCESS })
  } catch (err) {
    dispatch(handleError({ err, type: SIGNING_OUT_ERROR }))
  }
}
